import React, { useState } from 'react';
import { Badge, Button, UncontrolledTooltip } from 'reactstrap';
import { FaTrash } from 'react-icons/fa';

const ProductChangeIndicator = ({ product, onRemove }) => {
  const [showDetails, setShowDetails] = useState(false);
  const [showRemoveTooltip, setShowRemoveTooltip] = useState(false);

  if (!product || product.status === 'unchanged') return null;

  const getIcon = () => {
    switch (product.status) {
      case 'removed':
        return (
          <Badge color="danger" pill>
            Removido
          </Badge>
        );
      case 'changed':
        return (
          <Badge color="warning" pill>
            Alterado
          </Badge>
        );
      default:
        return null;
    }
  };

  const renderTooltipContent = () => {
    if (product.status === 'removed') {
      return (
        <div>
          <strong>Produto removido do catálogo</strong>
          <p>Este produto não está mais disponível no catálogo atual.</p>
        </div>
      );
    }

    if (product.status === 'changed' && product.changes) {
      return (
        <div>
          <strong>Alterações detectadas:</strong>
          <ul className="mb-0 pl-3">
            {product.changes.map((change, idx) => (
              <li key={idx}>
                {change.field === 'price' ? (
                  <span>
                    Preço: R$ {change.oldValue.toFixed(2)} → R${' '}
                    {change.newValue.toFixed(2)}
                  </span>
                ) : change.field === 'name' ? (
                  <span>
                    Nome: {change.oldValue} → {change.newValue}
                  </span>
                ) : null}
              </li>
            ))}
          </ul>
        </div>
      );
    }

    return null;
  };

  return (
    <div className="d-inline-block ml-2" style={{ cursor: 'pointer' }}>
      <span
        id={`product-change-${product.id}`}
        onClick={() => setShowDetails(!showDetails)}
        onMouseEnter={() => setShowDetails(true)}
        onMouseLeave={() => setShowDetails(false)}
      >
        {getIcon()}
      </span>
      <UncontrolledTooltip
        placement="right"
        target={`product-change-${product.id}`}
        isOpen={showDetails}
        toggle={() => setShowDetails(!showDetails)}
        fade={false}
        className="product-change-tooltip"
      >
        {renderTooltipContent()}
      </UncontrolledTooltip>
      {product.status === 'removed' && (
        <span className="ml-2">
          <Button
            color="danger"
            size="sm"
            id={`remove-product-${product.id}`}
            onClick={onRemove}
          >
            <FaTrash />
          </Button>
          <UncontrolledTooltip
            placement="top"
            target={`remove-product-${product.id}`}
            isOpen={showRemoveTooltip}
            toggle={() => setShowRemoveTooltip(!showRemoveTooltip)}
            fade={false}
          >
            Este produto será removido e só poderá ser usado novamente caso seja
            habilitado no catálogo.
          </UncontrolledTooltip>
        </span>
      )}
    </div>
  );
};

export default ProductChangeIndicator;
